import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import InputFields from "../../utils/UserInput";
import { message, Modal } from "antd";
import { updateRequest } from "../../utils/APICall";
import { useSelector } from "react-redux";
import moment from "moment";
import { XMarkIcon } from "@heroicons/react/16/solid";

const UpdateDepartForm = ({ visible, onClose, singleData }) => {
  // console.log("singleData", singleData)
  const { users } = useSelector((state) => state.user || {})
  const [formData, setFormData] = useState({
    vdeptitle: "",
    vtimein: "",
    vtimeout: "",
    vsickleaves: "",
    vcasualleaves: "",
    taskAccess: ""
  });
  const convertTo24Hour = (timeStr) => {
    if (!timeStr) return "";
    return moment(timeStr, "hh:mm A").format("HH:mm");
  };
  useEffect(() => {
    if (singleData) {
      setFormData({
        vdeptitle: singleData?.TITLE || "",
        vtimein: convertTo24Hour(singleData?.TIMEIN) || "",
        vtimeout: convertTo24Hour(singleData?.TIMEOUT) || "",
        vsickleaves: singleData?.SICKLEAVES || "",
        vcasualleaves: singleData?.CASUALLEAVES || "",
        taskAccess: singleData?.TASKACCESS == 1 ? true : false,
      });
    }
  }, [singleData]);

  const validationSchema = Yup.object().shape({
    vdeptitle: Yup.string().required("Title is required"),
    vtimein: Yup.string().required("Time In is required"),
    vtimeout: Yup.string().required("Time Out is required"),
  });

  const handleSubmit = async (values, { resetForm, setSubmitting }) => {
   function addGracePeriod(timeIn, gracePeriodMinutes) {
    const [hours, minutes] = timeIn.split(":").map(Number);
    const date = new Date();
    date.setHours(hours, minutes + gracePeriodMinutes, 0, 0);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hh = String(date.getHours()).padStart(2, "0");
    const mm = String(date.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hh}:${mm}:00`;
  }
   function toLocalISO(timeStr) {
    const [hours, minutes] = timeStr.split(":").map(Number);
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hh = String(hours).padStart(2, "0");
    const mm = String(minutes).padStart(2, "0");
    return `${year}-${month}-${day}T${hh}:${mm}:00`;
  }

    function convertToISOTime(timeStr) {
      const today = new Date();
      const [hours, minutes] = timeStr?.split(":").map(Number);
      today.setHours(hours, minutes, 0, 0);
      return today;
    }

    try {
      let gracetime = addGracePeriod(values.vtimein, 15);
      const obj = {
        ...values,
        vdepartmentid: singleData?.CODE,
        vtimein: toLocalISO(values.vtimein),
        vtimeout: toLocalISO(values.vtimeout),
        vgracetimeperiod: gracetime,
        vcreatedby: `${users?.FIRSTNAME} ${users?.LASTNAME} | ${moment(Date.now()).format("DD-MM-YYYY HH:mm")}`,
      };
      console.log(obj)
      const response = await updateRequest("updateDept", obj);
      if (response.success) {
        message.success("Department Updated successfully");
        resetForm();
        onClose();
        window.location.reload();
      } else {
        message.error("Failed to update department");
      }
    } catch (error) {
      console.error("Error updating department:", error);
      message.error("Failed to update department");
    } finally {
      setSubmitting(false)
    }
  };

  const showConfirm = (values, formikBag) => {
    Modal.confirm({
      title: 'Confirm Update',
      content: 'Are you sure you want to update this department?',
      okText: 'Yes',
      cancelText: 'No',
      onOk: () => handleSubmit(values, formikBag),
      onCancel: () => formikBag.setSubmitting(false)

    });
  };

  return (
    <Modal
      title={
        <div className="text-xl font-bold text-center pb-3 dark:bg-gray-900 dark:text-gray-100">
          Update Department
        </div>
      }
      open={visible}
      onCancel={onClose}
      footer={null}
      closeIcon={
        <XMarkIcon
          className={"h-5 w-5  dark:text-white text-black"}
        />
      }
      className="dark:[&_.ant-modal-content]:bg-gray-900"

    >
      <Formik
        initialValues={formData}
        validationSchema={validationSchema}
        onSubmit={(values, formikBag) => showConfirm(values, formikBag)}
        enableReinitialize={true}
      >
        {({ isValid, dirty, isSubmitting }) => (
          <Form>
            <span className="grid grid-cols-1 gap-2 md:grid-cols-2 text-gray-800 dark:text-gray-200">
              <InputFields
                label="Title"
                type="text"
                placeholder="Department Title"
                name="vdeptitle"
              />
              <InputFields
                label="Time In"
                type="time"
                name="vtimein"
              />
              <InputFields
                label="Time Out"
                type="time"
                name="vtimeout"
              />
              <InputFields
                label="Sick Leave"
                type="text"
                placeholder="Sick Leave"
                name="vsickleaves"
              />
              <InputFields
                label="Casual Leave"
                type="text"
                placeholder="Casual Leave"
                name="vcasualleaves"
              />
              <InputFields
                label="Task Access"
                type="checkbox"
                name="taskAccess"
              />
              <button
                type="submit"
                disabled={!(isValid && dirty) || isSubmitting}
                className="mt-6 flex justify-center items-center mx-auto w-full max-h-10 bg-blue-500 text-white px-4 py-2 rounded"
              >
                {isSubmitting ? "Loading..." : "Update"}
              </button>
            </span>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default UpdateDepartForm;